import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/LineOfBusiness";

//Add LineOfBusiness
export const addLineOfBusiness = async (newData) => {
  const { data } = await axios.post(`${api_base_url}`, newData[0]);
  return data;
};

//Delete LineOfBusiness
export const deleteLineOfBusiness = async (ids) => {
  await axios.delete(`${api_base_url}/LineOfBusiness`, {
    data: ids,
  });
};

//Update LineOfBusiness
export const updateLineOfBusiness = async (updatedLineOfBusiness) => {
  const { data } = await axios.put(`${api_base_url}`, {
    ...updatedLineOfBusiness,
  });
  return data;
};

export const getLineOfBusiness = async () => {
  const { data } =  await axios.get(`${api_base_url}/GetLineOfBusiness`)
    return data;
};
